'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _cms = require('actions/cms');

var _Project = require('components/Project/Project');

var _Project2 = _interopRequireDefault(_Project);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Project
 *
 */
var mapStateToProps = function mapStateToProps(state) {
  var data = state.cms.data;
  var loading = state.cms.loading;

  var main = {};
  var body = {};
  var nextCaseStudy = {};

  if (data !== null) {
    var bodyBlocks = [];
    var fields = [];
    var type = data.getText('project.type');

    data.getSliceZone('project.body').slices.map(function (item) {
      switch (item.sliceType) {
        case 'text':
          item.value.toArray().map(function (slice) {
            bodyBlocks.push({
              type: 'text',
              copy: slice.getStructuredText('copy').asHtml()
            });
          });
          break;
        case 'audio':
          var audioFiles = [];

          item.value.toArray().map(function (slice) {
            audioFiles.push({
              file: slice.getLink('audio-item').url(),
              name: slice.getText('audio-name')
            });
          });

          bodyBlocks.push({
            type: 'audio',
            files: audioFiles
          });
          break;
        case 'image':
          item.value.toArray().map(function (slice) {
            bodyBlocks.push({
              type: 'image',
              image: slice.getImage('image').url
            });
          });
          break;
        case 'video':
          item.value.toArray().map(function (slice) {
            bodyBlocks.push({
              type: 'video',
              video: slice.getLink('video-item').url(),
              poster: slice.getImage('video-image').url
            });
          });
          break;
        case 'quote':
          item.value.toArray().map(function (slice) {
            bodyBlocks.push({
              type: 'quote',
              author: slice.getText('author') !== null ? slice.getText('author') : '',
              caption: slice.getText('caption'),
              role: slice.getText('role') !== null ? slice.getText('role') : '',
              image: slice.getImage('image') !== null ? slice.getImage('image').url : ''
            });
          });
          break;
        default:
          return;
      }
    });

    if (state.cms.projects !== null) {
      var projects = state.cms.projects;
      var currentUid = data.uid;
      var currentIndex = _lodash2.default.findIndex(projects, function (o) {
        return o.uid === currentUid;
      });
      var projectsLength = projects.length;
      var nextProjectData = void 0;

      if (currentIndex === projectsLength - 1) {
        nextProjectData = projects[0];
      } else {
        nextProjectData = projects[currentIndex + 1];
      }

      nextCaseStudy = {
        title: nextProjectData.getText('project.title'),
        subtitle: nextProjectData.getText('project.subtitle'),
        mainImage: nextProjectData.getImage('project.main-image').url,
        url: 'work/' + nextProjectData.uid
      };
    }

    if (type === 'technical') {
      if (data.getGroup('project.technical-fields')) {
        data.getGroup('project.technical-fields').toArray().map(function (item) {
          var field = item.getText('technical-field');
          fields.push(field);
        });
      }
    } else {
      if (data.getGroup('project.fields')) {
        data.getGroup('project.fields').toArray().map(function (item) {
          var field = item.getText('field');
          fields.push(field);
        });
      }
    }

    main = {
      title: data.getText('project.title'),
      subtitle: data.getText('project.subtitle'),
      strap: data.getStructuredText('project.strap').asHtml(),
      mainImage: data.getImage('project.main-image').url,
      client: data.getText('project.client'),
      year: data.getNumber('project.year'),
      type: data.getText('project.type'),
      fields: fields
    };

    body = {
      blocks: bodyBlocks
    };
  }

  return {
    loading: loading,
    data: data,
    main: main,
    body: body,
    nextCaseStudy: nextCaseStudy
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  return {
    fetchProject: function fetchProject(slug) {
      dispatch((0, _cms.fetchProject)(slug));
    },
    fetchProjects: function fetchProjects() {
      dispatch((0, _cms.fetchProjects)());
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Project2.default);


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project.js
// module id = 349
// module chunks = 1